import { Provider, inject } from "mobx-react";
import { match, Route, RouteProps, Switch } from "react-router-dom";
import * as React from "react";

import PageStore from "app/PageStore";
import { PageLoading, NotFound } from "components/Layout";

import ChatStore from "./ChatStore";
import ChatService from "./ChatService";

const ListPage = React.lazy(() => import("./views/ListPage"));

interface RoutesProps {
  parentPath: string;
  match: match<{}>;
  pageStore?: PageStore;
}

@inject("pageStore")
class Routes extends React.Component<RoutesProps> {
  private stores = {};

  constructor(props: RoutesProps) {
    super(props);

    const chatService = new ChatService();
    const chatStore = new ChatStore(props.pageStore!, chatService);

    this.stores = {
      chatStore,
    };
  }

  public render() {
    const matchedUrl = this.props.match.url;
    return (
      <React.Suspense fallback={<PageLoading />}>
        <Provider {...this.stores}>
          <Switch>
            <Route exact path={matchedUrl} render={this.renderRfeUploadPage} />
          </Switch>
        </Provider>
      </React.Suspense>
    );
  }

  private renderRfeUploadPage = (routerProps: RouteProps) => (
    <ListPage
      {...routerProps}
      trail={[
        {
          name: "Chat",
          url: "/",
        },
      ]}
    />
  );
}

export default Routes;
